import type { AppGroupSection, Services } from '@wix/app-market-services';

const RECOMMENDED_FOR_YOU_APPS_COUNT = 4;

export const RECOMMENDED_FOR_YOU_TAG_SLUG = 'user-recommendations';

export async function getRecommendedForYouSection({
  services,
  appId,
}: {
  services: Services;
  appId?: string;
}): Promise<AppGroupSection | null> {
  const recommendedForYouTag = 'b561bac9-1dda-491f-ba14-8e0f5fd89f2c';
  try {
    const sections = await services.appMarketClientAggregator.getTagSections({
      tagIds: [recommendedForYouTag],
    });
    const appGroup = sections.getAppGroupSections()?.[0] ?? null;
    if (!appGroup) {
      return null;
    }

    // The section is fetched with one extra app so that, when the current app
    // page is itself recommended, we can drop it and still render a full row.
    const apps = appGroup.apps
      .filter((app) => app.id !== appId)
      .slice(0, RECOMMENDED_FOR_YOU_APPS_COUNT);
    const appIds = appGroup.appIds
      .filter((id) => id !== appId)
      .slice(0, RECOMMENDED_FOR_YOU_APPS_COUNT);

    return { ...appGroup, apps, appIds };
  } catch (e) {
    console.error(
      `[recommended-for-you-section.api] (getRecommendedForYouSection) failed for recommendedForYouTag:${recommendedForYouTag}, error:`,
      e,
    );
    return null;
  }
}
